module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image49.44ae9b98.jpg";